<!-- 骨架图 -->
<template>
  <div class="skeleton-wrap">
    <div class="skeleton1">
      <!-- <img :src="require('@/assets/app/1.png')" alt /> -->
    </div>
    <div class="skeleton2">
      <img :src="require('@/assets/app/2.png')" alt />
    </div>
    <div class="skeleton3">
      <img :src="require('@/assets/app/3.png')" alt />
    </div>
  </div>
</template>

<script>
//这里可以导入其它文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》from ‘《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //生命周期-创建之前
  beforeCreated() {},
  //生命周期-挂载之前
  beforeMount() {},
  //生命周期-更新之前
  beforUpdate() {},
  //生命周期-更新之后
  updated() {},
  //生命周期-销毁之前
  beforeDestory() {},
  //生命周期-销毁完成
  destoryed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
// 骨架
.skeleton-wrap {
  background: #f2f2f2;
}
.skeleton1 {
  width: 100%;
  height: 50vh;
  img {
    width: 100%;
    height: 100%;
  }
}
.skeleton2 {
  background-color: #fff;
  width: 100%;
  margin: 4vh 0;
  height: 16vh;
  img {
    width: 100%;
    height: 100%;
  }
}
.skeleton3 {
  background-color: #fff;
  margin: 4vh 0;
  width: 100%;
  height: 20vh;
  border-bottom: 1px solid #f2f2f2;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>